export enum Selection {
    SEATMAP,
    BEST_SEAT,
}